import React from "react";
import InternshipDirectoryListing from "./listing";

export default function CompletedInternshipDirectory(props) {
  return (
    <InternshipDirectoryListing
      {...props}
      fetchType="completed"
      title="Completed Internships & Training"
      pageTitle="Completed Internships & Training"
      dateLabel="Completed On"
      emptyMessage="No completed internships found"
    />
  );
}
